import { ConversationBase } from '../../conversations/common/models/conversation-base.model';
import { UserPermission } from '../../users/models/user-permission.enum';
import { WorkItemIntegration } from './work-item-integrations.model';

const languageOverrides = new Map<string, string>([
  ['en-US', 'en-US'],
  ['pt-BR', 'pt-BR'],
  ['zh-CN', 'zh-CN'],
  ['zh-TW', 'zh-TW'],
  ['nb-NO', 'no']
]);

const getLanguageCode: (locale: string) => string = (locale) => {
  try {
    return languageOverrides.has(locale)
      ? languageOverrides.get(locale)
      : new (Intl as any).Locale(locale).language;
  } catch(e) {
    console.error('Language code conversion for External Contacts panel failed.', e);
    return languageOverrides.get('en-US');
  }
};

export const externalContactIntegration: WorkItemIntegration = {
  id: 'external-contact',
  svgIconName: 'person-filled',
  tooltip: 'tooltips.gcExternalContactIntegration',
  title: 'tooltips.gcExternalContactIntegration',
  parseUrl: (conversation: ConversationBase, gcDomain: string, locale: string): string => {
    const externalContactId = conversation.customerParticipant.externalContactId;
    const language = getLanguageCode(locale);

    return `https://apps.${gcDomain}/external-contacts-ACD/#/agent/contact/${externalContactId}?` +
      'searchTerm=&isLocal=false&defaultCountryCode=US&isNotCX=true&' +
      `locale=${language}&pcTLD=${gcDomain}&pcEnvironment=${gcDomain}&interactionId=${conversation.id}`;
  },
  permissions: [UserPermission.ExternalContactView]
};
